//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
  mdiChevronRight,
} from '@mdi/js'

export default {
  name: 'ResultsCard',
  props: {
    myTeamName: {
      type: String,
      default: '',
      required: true,
    },
    rivalTeamName: {
      type: String,
      default: '',
      required: true,
    },
    myTeamResult: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    rivalTeamResult: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    myTeamShield: {
      type: String,
      default: '',
    },
    rivalTeamShield: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      icons: {
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        mdiChevronRight,
        teamShield: require('@/assets/images/svg/team-shield.svg'),
      },
    }
  },
}
